import { useState } from 'react';
import type { BaseOption } from '@witmetrics/unison-core';

export function useOption<T extends BaseOption = BaseOption>(
  initialOption?: T
) {
  const [option, setOption] = useState<T | null>(initialOption ?? null);

  const clearOption = () => setOption(null);

  return [option, setOption, clearOption] as const;
}
